import ArticlesList from "components/lists/products/ArticlesList";
import PageLayout from "../components/layout/PageLayout";

import { useSession } from "providers/SessionProvider";
import FileImportArticles from "components/FileImport/FileImportArticles";

export default function ArticlesPage() {
  const { clients, containers, units } = useSession();

  return (
    <PageLayout
      pageTitle="Artículos"
      pageDesc="Altas, bajas y modificaciones."
      importButton={
        <FileImportArticles
          clients={clients}
          containers={containers}
          units={units}
        />
      }
    >
      <ArticlesList />
    </PageLayout>
  );
}
